import { CALCULATION_FREQUENCIES } from './constants';

export const convertByFrequency = (weekly, frequency) => {
  let matchedFrequency = CALCULATION_FREQUENCIES[frequency];
  if (!matchedFrequency) {
    return weekly;
  }
  return weekly * matchedFrequency.weeksIn;
};

export const convertToFrequency = (amount, fromFrequency, toFrequency) => {
  let matchedFrequency = CALCULATION_FREQUENCIES[fromFrequency];
  if (!matchedFrequency) {
    return amount;
  }
  let weeklyValue = amount / matchedFrequency.weeksIn;
  return convertByFrequency(weeklyValue, toFrequency);
};
